module.exports = __webpack_public_path__ + "img/image156.2c9b3e55.jpg";